import { Icon } from '@blueprintjs/core';
import { Box, CustomTable, Text } from 'ui-components';
import CopyIDButton from '../../../components/copy-id-button';


type TableDataT = {
	headers: string[];
	rows: Record<string, string>[];
};
type CompanyTablePropsT = {
	tableData: TableDataT;
	toggle: (source: HTMLInputElement) => void;
	handleRowSelect: (row: Record<string, string>, checked: boolean) => void;
	selectedTableData: Record<string, string>[]
};
const CompanyTable = ({
	tableData,
	toggle,
	handleRowSelect,
	selectedTableData
}: CompanyTablePropsT) => {
	return (
		<CustomTable>
			<thead>
				<tr key={`tableheadrow`}>
					<th key={`tableheadcheckbox`}>
						<input
							type="checkbox" id="tableheader"
							onClick={(e) => toggle(e.currentTarget as HTMLInputElement)}
						/>
					</th>
					{tableData.headers.map((label, index) => (
						<th key={index}>{label}</th>
					))}
				</tr>
			</thead>
			<tbody>
				{tableData.rows.map((row, index) => (
					<tr key={index}>
						<td key={`checker${index}`}><input type="checkbox" checked=
							{selectedTableData.some((r) => r.company_name === row.company_name)}
							name="select" onChange={(e) => handleRowSelect(row, e.target.checked)} key={row.company_number} /></td>
						{tableData.headers.map((label, cellIndex) =>
							cellIndex == 1 ? (
								<CopyIDButton id={`${row[label]}`}>
									<Text ellipsis>{row[label]}</Text>
								</CopyIDButton>
							) : (
								<td key={cellIndex}>

									{cellIndex == 0 ? (
										<Box items="center" gap={"small"}>
											<span>{row["company_name"]}</span>
											<IconLinkCell
												value={`https://find-and-update.company-information.service.gov.uk/company/${row["company_number"]}`}
											/>
										</Box>
									) : (
										row[label]
									)}
								</td>
							)
						)}
					</tr>
				))}
			</tbody>
		</CustomTable>
	)
}

export default CompanyTable


export const IconLinkCell = ({ value }: { value?: string }) => {
  if (!value) return "";
  if (/^https?:/i.test(value)) {
    return (
      <a
        href={value}
        title={value}
        target="_blank"
        rel="noopener noreferrer"
        className="display-flex"
      >
        <Icon icon="share" size={10} />
      </a>
    );
  }
  return `MISSING PREFIX - ${value}`;
};